import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function SDCXOperatingSystems() {
    return (
        <React.Fragment>
            <h3>Operating Systems</h3>
            <ul>
                <li>Red Hat Enterprise Linux/CentOS 7 (64-bit)</li>
                <li>Microsoft Windows 10 (64-bit)</li>
                <li>Microsoft Windows Server 2012 R2</li>
                <li>Microsoft Windows Server 2016</li>
                <li>Microsoft Windows Server 2019</li>
            </ul>
            <p>
                <strong>Note</strong>: All systems running SDCX Server software on Microsoft Windows require an English
                version of the operating system.
            </p>
        </React.Fragment>
    );
}

SDCXOperatingSystems.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SDCXOperatingSystems);
